import type { PropertyListing } from "@gql";

interface Props {
  propertyListing: Pick<
    PropertyListing,
    "addressLine1" | "city" | "province" | "images" | "postalCode"
  >;
  lazy?: boolean;
}

const PropertyListingImage = ({ propertyListing, lazy }: Props) => {
  const { images, addressLine1, city, province, postalCode } = propertyListing;

  const renderImage = () => {
    if (!images || images?.length === 0) return <i className="fa fa-picture-o fa-2x" />;

    return (
      <img
        loading={lazy ? "lazy" : "eager"}
        src={images[0].url}
        alt={`Listing for: ${addressLine1}, ${city} ${province}, ${postalCode}`}
      />
    );
  };

  return <div className="property-listing-image-component">{renderImage()}</div>;
};

export { PropertyListingImage, type Props };
